export const EVENT_ID_REGEX = /^[A-Za-z0-9_-]{3,64}$/;

export const RESERVED_EVENT_IDS = new Set([
  "admin",
  "auth",
  "discover",
  "liked-you",
  "matches",
  "profile",
  "onboarding",
  "showcase",
  "animation-playground",
  "legal",
  "payment-failed",
  "payment-success",
  "app",
  "paypal-sandbox",
  "privacy",
  "terms",
  "access-expired",
  "chat",
  "match",
]);

const RESERVED_PATH_REDIRECTS: Record<string, string> = {
  admin: "/admin",
  auth: "/auth",
  discover: "/discover",
  "liked-you": "/liked-you",
  matches: "/matches",
  profile: "/profile",
  onboarding: "/onboarding",
  showcase: "/showcase",
  "animation-playground": "/animation-playground",
  legal: "/legal",
  "payment-failed": "/payment-failed",
  "payment-success": "/payment-success",
  app: "/app/paypal-sandbox",
  "paypal-sandbox": "/app/paypal-sandbox",
  privacy: "/privacy",
  terms: "/terms",
};

export function isValidEventSlug(eventId: string): boolean {
  return EVENT_ID_REGEX.test(eventId) && !RESERVED_EVENT_IDS.has(eventId);
}

export function getReservedPathRedirect(eventId: string): string | null {
  return RESERVED_PATH_REDIRECTS[eventId] ?? null;
}
